import DialogActions from "@mui/material/DialogActions";

export default DialogActions;
